enum DeviceType {
    'UNKNOWN' = 'UNKNOWN',
    'SMARTPHONE' = 'SMARTPHONE',
}

import { CreateUserDto } from '../user/create-user.dto';
import { CreateTagDto } from '../tag/create-tag.dto';
import { IsOptionalIf } from '../decorators';
import { IsString, IsNotEmpty, IsDefined, IsOptional, ValidateNested } from '@lgce/class-validator';
import { Expose, Type } from 'class-transformer';

export class CreateDeviceDto {
    @Expose()
    public id!: string;

    @IsString()
    @IsNotEmpty()
    @IsOptional()
    @Expose()
    public pinCode!: string;

    @IsString()
    @IsOptional()
    @Expose()
    public comment?: string;

    @IsString()
    @IsNotEmpty()
    @IsDefined()
    @Expose()
    public label!: string;

    @IsString()
    @IsNotEmpty()
    @IsDefined()
    @Expose()
    public phoneNumber!: string;

    @Expose()
    public type!: DeviceType;

    @IsDefined()
    @Expose()
    public subscriptionStart!: Date;

    @IsDefined()
    @Expose()
    public subscriptionEnd!: Date;

    @Expose()
    public customSubscriptionConfig!: any; // SubscriptionConfig;

    @IsString()
    @IsNotEmpty()
    @IsDefined()
    @Expose()
    public baseSubscriptionId!: string;

    @IsString()
    @IsNotEmpty()
    @IsOptionalIf((device: CreateDeviceDto) => !!device.owner)
    @Expose()
    public ownerId?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public pushNotificationToken!: string;

    @ValidateNested()
    @IsOptional()
    @Expose()
    @Type(() => CreateUserDto)
    public owner?: CreateUserDto;

    @IsString()
    @IsNotEmpty()
    @IsOptionalIf((device: CreateDeviceDto) => !!device.tag)
    @Expose()
    public tagId?: string;

    @IsOptional()
    @ValidateNested()
    @Expose()
    @Type(() => CreateTagDto)
    public tag?: CreateTagDto;

    @IsOptional()
    @Expose()
    public subscriptionConfigSyncedWithDevice?: boolean;
}
